// externals
import type { Reducer } from 'redux';
import { combineReducers } from 'redux';

// libraries
import type { StateTree } from '@makemydeal/dr-dash-types';
import type { AllRollbackActions } from '../actions/rollbackActionCreators';
import * as rollbackActionTypes from '../actionTypes/rollbackActionTypes';

// interfaces/types
import type { ConfigureStoreReducers } from './configureStoreTypes';

export const appReducersWithRollback =
    (reducers: ConfigureStoreReducers): Reducer =>
    (state, action: AllRollbackActions) => {
        switch (action.type) {
            case rollbackActionTypes.ROLLBACK_APP_STATE_FOR_SWITCH_VEHICLE: {
                const originalState = action.payload.original as StateTree;
                delete originalState.router;
                delete originalState.navigation;
                return {
                    ...originalState,
                    router: state.router,
                    navigation: state.navigation,
                    config: state.config,
                    changeVehicle: state.changeVehicle
                };
            }
            default: {
                return combineReducers(reducers)(state, action);
            }
        }
    };
